<template>
    <VueHtml2pdf ref="html2Pdf" :show-layout="false" :manual-pagination="false" float-layout enable-download
                 preview-modal :paginate-elements-by-height="800" :filename="fileName" :pdf-quality="2"
                  pdf-format="a4" pdf-orientation="landscape" pdf-content-width="1100px" class="pdf-work-analyzer">
        <section slot="pdf-content">
            <section class="pdf-item">
                <div class="brand-background">
                    <img alt="logo" style="height: 80px; width: 150px" :src="headerImage"/>
                </div>
            </section>

            <section class="pdf-item">
                <AppWorkAnalyzerTable id="pdf-table" :data="data" :pivot="queryPivot" :tableView="{code: ''}" :origin="'pdf'"
                                      :loading="loading" :operation-type="operationType" :drill-in-string="drillInString"/>
            </section>
        </section>
    </VueHtml2pdf>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import dateFormat from "@/mixins/DateMixin";
import AppWorkAnalyzerTable from "@/components/views/agriculture/work-analyzer/AppWorkAnalyzerTable.vue";

export default {
    mixins: [dateFormat],
    data() {
        return {
            headerImage: require(`@/assets/images/brands/${process.env.VUE_APP_THEME_IMAGE_HEADER}.png`)
        }
    },
    methods: {
        generateReport() {
            this.$refs.html2Pdf.generatePdf();
        },
        formatDate() {
            let formattedDate = this.dateFormat(new Date().getTime() / 1000, 'GMT')
            return formattedDate.replaceAll('/', '')
        }
    },
    props: {
        data: {
            type: Object
        },
        queryPivot: {
            type: String
        },
        drillInString: {
            type: String
        },
        operationType: {
            type: Object
        },
        loading: {
            type: Boolean
        }
    },
    computed: {
        fileName: function () {
            return `${this.operationType.label}_${this.formatDate()}`
        }
    },
    components: {AppWorkAnalyzerTable, VueHtml2pdf}
}
</script>

<style scoped lang="scss">
@import "src/assets/styles/constants";

.pdf-work-analyzer {
    width: 100%;
    margin-left: -10px;
    background-color: #f4f4f4
}

.brand-background {
    display: flex;
    align-self: center;
    align-items: center;
    width: 102%;
    background-color: $aside-menu-item-active;
}
</style>
